import { Injectable } from '@odinjs/odin';
import { FileService } from '@philips-internal/oswald-ui-components';

import { ProductManualRoutesAPI } from '../constants';

@Injectable({})
export class ManualService {

  static download(id: number, fileName: string): Promise<Blob> {
    return FileService.download(ProductManualRoutesAPI.PRODUCT_MANUAL_DOWNLOAD,
      fileName,
      { id });
  }

}
